module.exports = "/static/assets/95287153dfcad0aadb5489385bd1e211.png";